import { initSlider } from './splidecust';

let baseSliderInstances = [];
const base = document.querySelectorAll('.base__splide');

const baseInitSliders = () => {
  if (base && !baseSliderInstances.length) {
    base.forEach(container => {
      const slider = initSlider(container, {
        perPage: 2,
        gap: '1.125rem',
        breakpoints: {
          668: {
            perPage: 1,
          },
        },
      });
      baseSliderInstances.push(slider);
    });
  }
};

let landSliderInstances = [];
const land = document.querySelectorAll('.land__splide');

const landInitSliders = () => {
  if (land && !landSliderInstances.length) {
    land.forEach(container => {
      const slider = initSlider(container, {
        perPage: 2,
        gap: '1rem',
        breakpoints: {
          768: {
            perPage: 2,
          },
          668: {
            perPage: 1,
          },
        },
      });
      landSliderInstances.push(slider);
    });
  }
};

let panoramaSliderInstances = [];
const panorama = document.querySelectorAll('.panorama__splide');

const panoramaInitSliders = () => {
  if (panorama && !panoramaSliderInstances.length) {
    panorama.forEach(container => {
      const slider = initSlider(container, {
        perPage: 2,
        gap: '1rem',
        breakpoints: {
          768: {
            perPage: 1,
          },
        },
      });
      panoramaSliderInstances.push(slider);
    });
  }
};

const destroySliders = () => {
  if (baseSliderInstances) {
    baseSliderInstances.forEach(instance => {
      instance.destroy();
    });
    baseSliderInstances = [];
  }
  if (landSliderInstances) {
    landSliderInstances.forEach(instance => {
      instance.destroy();
    });
    landSliderInstances = [];
  }
  if (panoramaSliderInstances) {
    panoramaSliderInstances.forEach(instance => {
      instance.destroy();
    });
    panoramaSliderInstances = [];
  }
};

const checkViewport = () => {
  baseInitSliders();
  landInitSliders();
  panoramaInitSliders();

  if (window.innerWidth > 960) {
    destroySliders();
  }
};

window.addEventListener('resize', checkViewport);
document.addEventListener('DOMContentLoaded', checkViewport);
